class AnnouncementCountdown extends HTMLElement {
  /** @type {number} */
  #timer = 0;

  /** @type {number} */
  #deadline = 0;

  connectedCallback() {
    const durationHours = Math.max(1, Number(this.dataset.durationHours) || 3);
    const duration = durationHours * 60 * 60 * 1000;
    const storageKey = `nuvolla-announcement-deadline-${durationHours}`;
    try { this.#deadline = Number(sessionStorage.getItem(storageKey)) || 0; } catch {}
    if (!this.#deadline || this.#deadline <= Date.now()) {
      this.#deadline = Date.now() + duration;
      try { sessionStorage.setItem(storageKey, String(this.#deadline)); } catch {}
    }
    this.#update();
    window.clearInterval(this.#timer);
    this.#timer = window.setInterval(this.#update, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #update = () => {
    const output = this.querySelector('time');
    if (!(output instanceof HTMLTimeElement)) return;
    const remaining = Math.max(0, Math.ceil((this.#deadline - Date.now()) / 1000));
    const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    const seconds = String(remaining % 60).padStart(2, '0');
    output.textContent = `${hours}:${minutes}:${seconds}`;
    output.dateTime = `PT${hours}H${minutes}M${seconds}S`;
  };
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
